/* global CONTENT_ROOT */
import cookies from 'rlink-cookies/cookies';
import getGdprCookieKey from 'rlink-cookies/getGDPRCookieKey';

export default function setGdprConsent (appName, gdprCookieVersion) {
  let re = CONTENT_ROOT.match(/^http[s]?:\/\/[^/]*(.*)$/);
  let path = (re) ? re[1] : '/';
  let wildcardDomain = window.location.hostname.split('.').slice(-2).join('.');

  cookies.setItem(
    getGdprCookieKey(appName, gdprCookieVersion),
    true,
    Infinity,
    path,
    wildcardDomain,
  );
}



// WEBPACK FOOTER //
// ./lib/rlink-cookies/setGdprConsent.js